<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-6 mb-5">
        <div>
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check"
            active-color="#c698fa"
          ></step-progress>
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <b-button
          variant="secondary"
          @click="prevClick"
          class="mr-3"
        ><i
            class="fas fa-chevron-left text-grey"
            aria-hidden="true"
          ></i></b-button>
      </div>
      <div class="col-md-12 ">
        <h4>
          Product: {{ productPackage.name }}
        </h4>
        <hr class="mt-4" />
      </div>
      <div class="col-md-12 " v-if="false">

        Member:
        <div class="col-md-5">
          <div class="d-flex justify-content-center">
            <div class="input-group">
              <input
                @keyup="memberSearch"
                class="form-control"
                type="text"
                id="memberSearchInput"
                name="memberSearchInput"
                v-model="memberSearchInput"
                placeholder="Search member ID, name, or phone.."
                aria-label="Search member ID, name, or phone.."
              />
              <div class="input-group-append">
                <span
                  class="input-group-text pl-4 pr-4"
                  id="searchbtt"
                  @click.prevent="memberSearch"
                ><i
                    class="fas fa-search text-grey"
                    aria-hidden="true"
                  ></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-4">
          <div>
            <h5 v-if="isSearch">Search Result:</h5>
            <sale-member-table
              v-if="isSearch"
              :memberResult="memberResult"
              v-on:member-created="memberCreated"
            ></sale-member-table>

          </div>

          <!--<test-table></test-table>-->
        </div>

        <div
          v-if="selectMember != null"
          class=" inline-block"
        >
          <h5 class="">
            Selected Member: {{ selectMember.firstname }}
            {{ selectMember.lastname }}
            <small><a
                href="#"
                @click.prevent="removeMember"
              >Remove</a></small>
          </h5>
        </div>

        <hr class="mt-4" />
      </div>
      <div class="col-md-12">
        <form
          class="form-horizontal"
          role="form"
        >
          <div class="col-md-12">
            <label
              for="paidby"
              class="mr-4 control-label"
            >Paid By</label>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_cash"
                value="CASH"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_cash"
              >Cash</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_bank"
                value="BANK"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_bank"
              >Bank Transfer</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_card"
                value="CARD"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_card"
              >Credit Card</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby != 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_free"
                value="FREE"
                v-model="payment.paidby"
                @click="setPaymentFree"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_free"
              >FREE</label>
            </div>
            <div
              class="form-check form-check-inline"
              v-if="payment.paidby == 'SUB'"
            >
              <input
                class="form-check-input"
                type="radio"
                name="paidby"
                id="paidby_sub"
                value="SUB"
                v-model="payment.paidby"
                :v="$v.payment.paidby"
              />
              <label
                class="form-check-label"
                for="paidby_sub"
              >Subscription</label>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-md-6">
              <div class="form-group form-inline mt-3">
                <label
                  for="qty"
                  class="col-sm-3 control-label"
                >Price</label>
                <div class="">
                  <input
                    type="text"
                    id="price"
                    name="price"
                    placeholder="Price"
                    class="form-control"
                    v-model="payment.price"
                    :disabled="!editPrice"
                  />
                  <a
                    href="#"
                    @click.prevent="editPrice = 1"
                    class="ml-2"
                  >Edit</a>
                </div>
              </div>

              <div class="form-group form-inline">
                <label
                  for="qty"
                  class="col-sm-3 control-label"
                >Quantity</label>
                <div class="">
                  <input
                    type="text"
                    id="qty"
                    name="qty"
                    placeholder="Quantity"
                    class="form-control"
                    v-model="payment.qty"
                  />
                </div>
              </div>

              <div class="form-group form-inline">
                <label
                  for="discount"
                  class="col-sm-3 control-label"
                >Discount</label>
                <div class="">
                  <input
                    type="text"
                    id="discount"
                    name="discount"
                    placeholder="Discount"
                    class="form-control"
                    v-model="payment.discount"
                  />
                  <select
                    class="form-control ml-2"
                    name="discount_unit"
                    v-model="payment.discount_unit"
                  >
                    <option value="percent">Percent</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>

              <div class="form-group form-inline mt-3">
                <label
                  for="note"
                  class="col-sm-3 control-label"
                >Note</label>
                <div class="">
                  <textarea
                    name="note"
                    rows="2"
                    cols="40"
                    placeholder="Add note here.."
                    class="form-control"
                    v-model="payment.note"
                  >
                  </textarea>
                </div>
              </div>
              <div
                class="form-group form-inline saledatediv p-3"
                v-if="isAuthLv2"
              >
                <label
                  for="sale_date"
                  class="col-sm-3 control-label"
                >Sale On</label>
                <div class="">
                  <date-picker
                    v-model="payment.sale_date"
                    valueType="format"
                  ></date-picker>
                </div>
              </div>
            </div>

          </div>

          <hr />
          <div class="row">
            <div class="col-md-12">
              <h4>Sub Total: {{ getSubTotalPrice }}</h4>
            </div>
            <div class="col-md-12">
              <h4>Discount: {{ getDiscount }}</h4>
            </div>
            <div class="col-md-12">
              <h4>Total: {{ getTotalPrice }}</h4>
            </div>
          </div>
        </form>
        <!-- /form -->
      </div>
    </div>
    <div
      v-if="!isSubmit"
      class="mt-4 d-flex justify-content-center mb-5"
    >
      <b-button
        size="lg"
        block
        variant="primary"
        @click.prevent="PaymentSubmit"
        :class="{ invalid: $v.$invalid }"
      >Buy</b-button>
    </div>
    <div
      v-else
      class="mt-4 justify-content-center mb-5"
    >
      <div
        class="alert alert-success"
        role="alert"
      >
        Sale Completed.
        <a
          href="#"
          @click.prevent="resetSaleProduct"
        >Click here to start again.</a>
      </div>
    </div>

  </div>
</template>
<script>
import { isAuthLv1, isAuthLv2 } from "./../js/utils/global.js";
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { validationMixin } from "vuelidate";
import SaleMemberTable from "./SaleMemberTable.vue";
import {
  required,
  minLength,
  between,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  data() {
    return {
      mySteps: ["Product", "Payment"],
      loading: false,
      isSubmit: false,
      isSearch: false,
      memberSearchInput: null,
      memberResult: null,
      selectMember: null,

      currentStep: 1,
      productPackage: this.$store.getters.getSaleProductPackage,
      payment: {
        price: this.$store.getters.getSaleProductPackage.price,
        qty: "1",

        discount: 0,
        discount_unit: "percent",
        discount_final: 0,
        paidby: null,
        total: 0,
        note: null,
        sale_date: null
      },
      fsubtotal: 0,
      fdiscountfinal: 0,
      ftotal: 0,
      employee_id: null,
      editPrice: false,
      editSession: false,
      editDuration: false,
      paymentcache: null
    };
  },
  validations: {
    payment: {
      paidby: {
        required
      }
    }
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    },
    isAuthLv2,
    packageType() {
      return this.$store.getters.getSaleProductPackage.type;
    },
    memberName() {
      if (this.$store.getters.getSaleProductMember == null) {
        return "None - Walk In";
      }
      let membername =
        this.$store.getters.getSaleProductMember.firstname +
        " " +
        this.$store.getters.getSaleProductMember.lastname;
      return membername;
    },
    getSubTotalPrice() {
      this.fsubtotal = this.payment.price * this.payment.qty;
      return this.fsubtotal;
    },
    getDiscount() {
      if (this.payment.discount_unit == "percent") {
        this.fdiscountfinal = this.fsubtotal * (this.payment.discount / 100);
      } else if (this.payment.discount_unit == "amount") {
        this.fdiscountfinal = this.payment.discount;
      }
      this.payment.discount_final = this.fdiscountfinal;
      return this.fdiscountfinal;
    },

    getTotalPrice() {
      this.ftotal = this.fsubtotal - this.fdiscountfinal;
      this.payment.total = this.ftotal;
      return this.ftotal;
    }
  },
  methods: {
    async memberSearch() {
      //console.log(this.memberSearchInput);

      if (
        this.memberSearchInput == "" ||
        this.memberSearchInput == null ||
        this.memberSearchInput.length < 2
      ) {
        return false;
      }

      this.isSearch = false;
      await axios
        .get("/api/members/find", {
          params: {
            keysearch: this.memberSearchInput
          }
        })
        .then(response => {
          //console.log(response.data);
          this.memberResult = response.data;

          //console.log(response.data.data);
          this.loading = false;
          this.isSearch = true;
        });
    },
    memberCreated(data) {
      this.$store.dispatch("setSaleProductMember", data);
      //console.log(data.email);
      this.selectMember = data;
      this.isSearch = false;
      //console.log(this.selectMember);
    },
    removeMember() {
      this.$store.dispatch("setSaleProductMember", null);
      this.selectMember = null;
    },
    setPaymentFree() {
      //this.paymentcache = this.payment.price;
      this.payment.price = 0;
    },
    prevClick() {
      this.$store.dispatch("setSaleProductState", 0);
    },
    async PaymentSubmit() {
      if (this.payment.paidby == null) {
        return false;
      }

      this.$store.dispatch("setSaleProductPayment", this.payment);

      this.currentStep = 2;
      const self = this;
      this.loading = true;
      //console.log(this.$store.getters.getSaleProductMember);
      await axios
        .post("/api/purchases/productbuy", {
          //member: this.$store.getters.getSaleProductMember,
          member: null,
          purchase: this.$store.getters.getSaleProductPayment,
          package: this.$store.getters.getSaleProductPackage
        })
        .then(response => {
          this.isSubmit = true;
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          /* setTimeout(function() {
            this.isSubmit = false;
            self.resetSale();
          }, 500); */
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => (this.loading = false));

      //console.log(this.payment);
    },
    resetSaleProduct() {
      this.$store.dispatch("resetSaleProduct");
    }
  },
  components: {
    "step-progress": StepProgress,
    DatePicker,
    SaleMemberTable
  },
  mounted() {}
};
</script>
<style scoped>
input[type="radio"] {
  transform: scale(1.5);
}
.saledatediv {
  background-color: orange;
}
</style>
